<template>
	<div id="municipalInfo" data-role="page">
		<!-- content -->
		<div class="municipalInfo-content" data-position="fixed">
              <!-- 未連接至網路的提醒 -->
            <div v-if="!closeOffline && isOffline" class="v3offline">
                <i class="icon-exclamation-mark-circle"></i>
                <p>未連接至網路</p>
                <div @click="closeOfflineHandle"><i class="icon-close"></i></div>
            </div>
			<!-- swiperTop 分類 -->
			<div id="infoTop" class="swiper-container swiperTop">
				<swiper :options="swiperTop" ref="infoTop">
					<swiper-slide class="swiper-slide" v-for="(typeVal,typeIdx) in infoType" :key="typeIdx" :typeId="typeVal.typeId">{{typeVal.typeName}}</swiper-slide>
				</swiper>
			</div>
            <div id="infoPages" class="swiper-container swiperPages">
                <swiper :options="swiperPages" class="swiper-wrapper" ref="infoPages">
					<swiper-slide class="swiper-slide" v-for="(typeVal,typeIdx) in infoType" :key="typeIdx" :typeId="typeVal.typeId" :selected="typeVal.typeId == 1">
						<div class="detailWrap">
							<div class="articleList">
								<ul v-if="typeVal.typeList && typeVal.typeList.length>0">
									<li v-for="(infoVal,infoIdx) in typeVal.typeList" :key="infoIdx" @click="GoDetail(typeVal)">
                                        <router-link :to="{name:'v3municipalInfoDetail', params: { type: `${typeVal.typeId == 1 ? 'municipal' : 'village'}`, id: infoVal.MessageId}}">
                                            <div class="topicImg">
                                                <!-- <div class="mainImg" v-if="news.title_img != ''" v-lazy:background-image="news.title_img" ></div>
                                                <div class="mainImg" v-if="news.title_img == ''"></div> -->
                                            </div>
                                            <div class="txt-info">
                                                <span class="article_desc">{{ infoVal.MessageTitle }}</span>
                                                <span class="article_date">{{ DateFormat(infoVal.MessageDate,'YYYY/MM/DD') }}</span>
                                                <template v-if="typeVal.typeId == 2">
                                                    <template v-if="isGetProfileInfoSuccess">
                                                        <span v-if="villageIdx < 3" class="cgy-tag" v-for="(villageVal,villageIdx) in infoVal.VillageName" :key="villageIdx">{{ villageVal }}</span>
                                                        <span v-if="infoVal.VillageName.length > 3" class="cgy-tag">＋{{ infoVal.VillageName.length - 3 }}</span>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <span class="cgy-tag">{{ infoVal.MessageType }}</span>
                                                </template>
                                                <i class="icon-chevron-right"></i>
                                            </div>
                                        </router-link>
									</li>
								</ul>
                                <div v-else-if="typeVal.typeList == null" class="empty">
                                    <!-- 初始空狀態 -->
                                </div>
                                <div v-else class="empty">
                                    <div class="txt-box">
                                        <i class="icon-system_empty"></i>
                                        <h4>噢不！<br/>{{ typeVal.typeName }}尚未有任何訊息</h4>
                                    </div>
                                </div>
							</div>
						</div>                        
                    </swiper-slide>            
				</swiper>
            </div>
            <!-- <div id="footer" @click="OpenMunicipalMail">
                <div class="wrapFooter">
                    <p class="title">市政信箱</p>
                </div>
            </div> -->
		</div>
        <div v-show="v3Toast.show" class="v3Toast">{{v3Toast.text}}</div>
    </div>        
</template>

<script lang="js">
export default {
    data () {
        return {
            scrollTop: 0,
            swiperTop: {
                slidesPerView: '2',
                aginationClickable: true,//此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换。
                spaceBetween: 0,//slide之间的距离（单位px）。
                freeMode: true,//默认为false，普通模式：slide滑动时只滑动一格，并自动贴合wrapper，设置为true则变为free模式，slide会根据惯性滑动且不会贴合。
                loop: false,//是否可循环
            },
            swiperPages:{
                direction: 'horizontal',//Slides的滑动方向，可设置水平(horizontal)或垂直(vertical)。
                loop: false,
                preloadImages: false,
                lazy: true,
                autoHeight: false //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。
            },
            infoType: [
                {typeId: 1, typeName: "市政資訊", typeList: null},
                {typeId: 2, typeName: "里長公告", typeList: null},
            ],
            Authority: false,
            toastControl:{
                show: false,
                full: false,
                content: '',
                showTime: 1000
            },
            comList: [],
            isGetProfileInfoSuccess: true,
            closeOffline:false,
            v3Toast:{
                show: false,
                text: '',
                duration: 1000
            },
        }
    },
    watch: {
        isOffline: function(val) {
            // 在下次無網路時再度打開上面的 top tip
            if (!val) this.closeOffline = false
        }
    },
    mounted(){
        let vobj = this;
        this.CheckAuthority()
        this.InitSwiperList()
        this.GetProfileInfo().then((r)=>{
            this.isGetProfileInfoSuccess = true
            let isNtpc = this.comList.some((v,i)=>{
                if(v.municipalType == 'Ntpc'){
                    return true
                }
            })
            let villageList = this.comList.map((v)=>{
                if(v.villageId != null){
                    return v.villageId
                }
            })
            this.GetMunicipalList(isNtpc ? 'Ntpc' : '')
            if(villageList && villageList.length > 0){
                villageList = Array.from(new Set(villageList))
                this.GetVillageList(villageList)
            }
            $("#infoPages .swiper-slide").outerHeight($(window).outerHeight() - $('#infoTop').outerHeight() - $('#footer').outerHeight())
        }).catch((e)=>{
            this.isGetProfileInfoSuccess = false
            console.log(e)
            this.GetMunicipalList('Ntpc')
            this.GetVillageList([])
            $("#infoPages .swiper-slide").outerHeight($(window).outerHeight() - $('#infoTop').outerHeight() - $('#footer').outerHeight())
        })
        //啟用 footer 的active 事件 By default, Safari Mobile does not use the :active state unless there is a touchstart event handler on the relevant element or on the <body>
        document.querySelector('#footer').addEventListener('touchstart', function () { });
    },
    activated() {
        // 如果曾滚动过,则还原位置
        if (this.scrollTop) {
            const scrollDom = document.querySelector('#infoPages .swiper-slide-active')
            scrollDom.scrollTop = this.scrollTop;
        }
    },
    methods:{
        //取得市政訊息列表
        GetMunicipalList(municipalType){
            let vobj=this;
            return new Promise((resolve, reject)=>{
                if(!municipalType){
                    return reject('xxx')
                }
                this.axios.get(`${process.env.SmartlifeCoreApi}/MunicipalInformation/${municipalType}`,{
                    // headers:{Authorization: Token},
                }).then((response) => {
                    if(response.status == 200){
                        vobj.infoType = vobj.infoType.map((res)=>{
                            let returnObj = res
                            if(returnObj.typeId == 1){
                                returnObj.typeList = response.data.Data
                            }
                            return returnObj
                        })
                    }else{
                        Promise.reject('status 不是200')
                    }
                    setTimeout(()=>{
                        vobj.InitSwiperList()
                    },500)
                }).catch((err) => {
                    console.log(err)
                    vobj.InitSwiperList()
                })
            })
        },
        //取得新訊列表
        GetVillageList(villageId){
            let vobj=this;
            return new Promise((resolve, reject)=>{
                this.axios.get(`${process.env.SmartlifeCoreApi}/MunicipalInformation/Village/`,{
                    // headers:{Authorization: Token},
                    params: {
                        villageIds: villageId
                    }
                }).then((response) => {
                    if(response.status == 200){
                        let a = vobj.infoType
                        a = vobj.infoType.map((res)=>{
                            let returnObj = res
                            if(returnObj.typeId == 2){
                                returnObj.typeList = response.data.Data.map((v)=>{
                                    v.VillageName = v.VillageName.filter((village)=>{
                                        return village != null
                                    })
                                    v.VillageName = Array.from(new Set(v.VillageName)) //篩選重複項
                                    return v
                                })
                            }
                            return returnObj
                        })
                        vobj.$set(vobj, 'infoType', a)
                        console.log(vobj.infoType);
                    }else{
                        Promise.reject('status 不是200')
                    }
                }).catch((err) => {
                    console.log(err)
                })
            })
        },
        //取得使用者社區資料
        GetProfileInfo(){
            let vobj=this;
            return new Promise((resolve, reject)=>{
                if(!v3Token || v3Token=='undefined' || v3Token=='null'){ 
                    return reject()
                }
                this.axios.get(`${process.env.SmartlifeCoreApi}/Profile/GetProfileInfo/`,{
                    headers:{KingnetAuth: 'CommunityUser ' + decodeURIComponent(v3Token)}
                }).then((response) => {
                    console.log(response)
                    if(response.data && response.data.Data && response.data.Data.plist && response.data.Data.plist.length>0){
                        this.comList = response.data.Data.plist
                        resolve(this.comList)
                    }else{
                        reject()
                    }
                }).catch((err) => {
                    console.log(err)
                    reject()
                })
            })
        },
        InitSwiperList(){
            const vobj = this
            const Top = vobj.$refs.infoTop.swiper;
            const Pages = vobj.$refs.infoPages.swiper;
            const TypeId = vobj.infoType[0].typeId
            const Selected = vobj.$route.query['tab']
            Top.slides.each(function(index, val){
                var ele = $(this);
                ele.on("click", function() {
                    $(".swiperTop .swiper-slide").removeClass("selected");
                    ele.addClass("selected");
                    Pages.slideTo(index, 500);
                })
                let nowTypeId = $(val).attr('typeId');
                if(Selected != undefined){
                    if(index == Selected){
                        $(".swiperTop .swiper-slide").removeClass("selected");
                        ele.addClass("selected");
                        Pages.slideTo(index, 0);
                    }
                }else{
                    if(nowTypeId == TypeId){
                        vobj.SlidesToPage(index);
                    }
                }
            })
            Pages.slides.each(function(index, val){
                var ele = $(this);
                ele.on('scroll', function(){
                    vobj.scrollTop = this.scrollTop
                });
            })
            Pages.on('slideChangeTransitionStart', function(){
                $(".swiperTop .swiper-slide").removeClass("selected");
                $(".swiperTop .swiper-slide").eq(this.activeIndex).addClass("selected");
                // vobj.$router.replace({query:{tab: this.activeIndex}})
            }).on('slideChangeTransitionEnd', function(){
                $(".swiperTop .swiper-slide").removeClass("selected");
                $(".swiperTop .swiper-slide").eq(this.activeIndex).addClass("selected");
                vobj.scrollTop = 0
                // vobj.$router.replace({query:{tab: this.activeIndex}})
            })
        },
        //切換頁面
        SlidesToPage(page){
            const Top = this.$refs.infoPages.swiper;
            const Pages = this.$refs.infoPages.swiper
            Pages.slideTo(page, 500);
            $(".swiperTop .swiper-slide").removeClass("selected");
            $(".swiperTop .swiper-slide").eq(page).addClass("selected");
        },
        //檢查權限
        CheckAuthority(){
            if(localStorage.getItem("v3token")=='' || localStorage.getItem("v3token") == null){
                this.Authority= false
            }else{
                this.Authority= true
            }
        },
        DateFormat(date, format){
            if(date){
                return this.$root.dateFormat(date, format)
            }else{
                return ''
            }
        },
        //打開市政信箱
        OpenMunicipalMail(){
            window.open('https://service.ntpc.gov.tw/contact/Ac991000.action',"_blank")
        },
        GoDetail(typeVal){
            var selectedType = typeVal.typeId == 1 ? 0 : 1
            this.$router.replace({query:{tab: selectedType}})
        },
        closeOfflineHandle(){
            this.closeOffline = true
        },
        showV3Toast(text) {
            clearTimeout(this.toastTimer)
            this.v3Toast.text = text;
            this.v3Toast.show = true;
            this.toastTimer = setTimeout(() => {
                this.v3Toast.show = false;
            }, this.v3Toast.duration);
        },
        
    },
    beforeRouteLeave (to, from, next) {
        const vm = this
         if(vm.isOffline){
                vm.showV3Toast('網路狀態異常')
        }else{
            next()
        }
    }
}
</script>
<style scoped>
.v3Toast {
  z-index: 10;
  position: fixed;
  left: 50%;
  top: 50%;
  border-radius: 10px;
  transform: translate(-50%, -50%);
  line-height: 27px; /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
  background: rgba(0, 0, 0, 0.7); /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
  padding: 7px 10px 6px; /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
  color: #fff;
  font-size: 15px; /* 2020/11/07 10:59 捨棄 gulidline 進行調整 */
  font-weight: 500;
}
.v3offline {
    position: fixed;
    z-index: 99;
    width: 100%;
    height: 44px;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 21px;
    font-size: 15px;
    font-weight: 400;
    text-align: center;
    color: #fff;
    background: rgba(66, 137, 167, .9); /* #4289a7 2020/11/19 13:37 BD mean this color */ 
    -webkit-transition: .5s;
    transition: .5s;
}
.v3offline > i {
    margin-right: 9px;
    font-size: 19px;
    width: 19px;
    height: 19px;
}
.v3offline div {
    position: absolute;
    top: 12px;
    right: 16px;
    font-size: 18px;
    width: 18px;
    height: 18px;
}
</style>




// WEBPACK FOOTER //
// src/components/v3/municipal/municipalInfo.vue